import { createSlice } from "@reduxjs/toolkit";

const initialToastData = {
  isShowing: false,
  message: "",
  isSuccess: true,
  duration: 2500
};

const toastDataSlice = createSlice({
  name: "toastData",
  initialState: initialToastData,
  reducers: {
    showToast: (state, action) => {
      state.isShowing = true;
      state.message = action.payload.message;
      state.isSuccess = action.payload.isSuccess;
      state.duration = action.payload.duration || 2500
    },
    hideToast: (state) => {
      state.isShowing = false;
    },
  },
});

export const selectToastData = (state) => state.toastData;

export const { showToast, hideToast } = toastDataSlice.actions;

export default toastDataSlice.reducer;
